// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__sMENM","spin":"LoadingSpinner_spin__pYJ3Z"};